$.ready(function() {
	game.pays.on('pay', function(e) {
		if (e.detail.type === 'scatter') {
			e.detail.box = false;
		}
	});
	
/*
	var pays = game.pays;
	
	pays.next = function(index, cycles) {
		if(!this.list.length) {
			return;
		}
		
		if(index >= this.list.length) {
			return this.next(0, cycles + 1);
		}
		
		if(cycles === 0 && this.list.length === 1) {
			return this.next(0, cycles + 1);
		}
		
		var pay = this.list[index];
		
		this.clear(true);
		this.canvas.strokeStyle = pay.color;
		
		if(typeof pay.line !== 'undefined') {
			this.drawLine(pay.line);
		}
		
		for(var spot in pay.spots) {
			spot = pay.spots[spot];
			
			var reel = spot[0];
			var row = spot[1];
			
			if(cycles > 0) {
				game.frame.reels[reel].symbols[row].addClass('win');
			}
			
			else {
				game.frame.reels[reel].symbols[row].addClass('pop');
			}
			
			// x, y, width, height
			var pos = this.getPosition(reel, row);
			pos[0] += this.canvas.lineWidth / 2;
			pos[1] += this.canvas.lineWidth / 2;
			pos[2] -= this.canvas.lineWidth;
			pos[3] -= this.canvas.lineWidth;
			
			if (!(pay.type === 'scatter')){
				this.canvas.clearRect(pos[0], pos[1], pos[2], pos[3]);
				this.canvas.strokeRect(pos[0], pos[1], pos[2], pos[3]);
			}
		}
		
		game.frame.addClass('win');
		
		if(pay.type === 'line') {
			pays.messaging.html('Line ' + (pay.line + 1) + ' wins ' + pay.win);
			pays.trigger('update', {line:pay.line + 1});
		}
		else if(pay.type === 'way') {
			pays.messaging.html('Symbol ' + pay.symbol + ' wins ' + pay.win);
		}
		else if(pay.type === 'scatter') {
			pays.messaging.html('Scatter symbol wins ' + pay.win);
		}
		
		timer = setTimeout(pays.next.bind(pays, index + 1, cycles), cycles === 0 ? 500 : 2000);
	};
*/
});


/** WEBPACK FOOTER **
 ** ./public-src/js/hide_trigger.js
 **/